export const COMPARISON_ALL_ENPOINT = "/compare-cars/all/";

const COMPARISON_LISTING_WITH_PAGE_NUMBER_ENDPOINT =
  "/compare-cars/all/page/:pageNumber([0-9]+)";

export const COMPARISON_LISTING_ENDPOINTS = [
  COMPARISON_ALL_ENPOINT,
  COMPARISON_LISTING_WITH_PAGE_NUMBER_ENDPOINT,
];

export const COMPARISON_LANDING_ENDPOINTS = "/compare-cars/";

export const COMPARISON_DETAILS_ENDPOINTS =
  "/compare-cars/:compareUrl([a-zA-Z0-9_-]+)/";
